import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon AddressIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const AddressIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 13 20">
      <path d="M6.5 0A6.34 6.34 0 000 6.15a5.86 5.86 0 00.86 3.07L6.5 20l5.65-10.81a5.84 5.84 0 00.85-3A6.34 6.34 0 006.5 0zm4.37 8.42v.08L6.5 16.76 2.19 8.52a.35.35 0 000-.08 4.4 4.4 0 01-.69-2.29 4.84 4.84 0 015-4.65 4.84 4.84 0 015 4.65 4.44 4.44 0 01-.63 2.27z" />
      <path d="M6.5 4A2.5 2.5 0 109 6.5 2.5 2.5 0 006.5 4zm0 3.5a1 1 0 111-1 1 1 0 01-1 1z" />
    </Icon>
  )
}
export default AddressIcon
